import { render, staticRenderFns } from "./coupions.vue?vue&type=template&id=ef7efce2&scoped=true&"
import script from "./coupions.vue?vue&type=script&lang=js&"
export * from "./coupions.vue?vue&type=script&lang=js&"
import style0 from "./coupions.vue?vue&type=style&index=0&id=ef7efce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7efce2",
  null
  
)

export default component.exports